import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import ajax from './plugins/ajax'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('./views/Index.vue')
    },
    {
      path: '/liquor/index',
      name: 'liqour',
      component: () => import('./views/liquor/Index.vue')
    },
    {
      path: '/liquor/browser',
      name: 'browser',
      component: () => import('./views/liquor/Browser.vue')
    },
    {
      path: '/liquor/country/:id',
      name: 'country',
      component: () => import('./views/liquor/LiquorCountry.vue')
    },
    {
      path: '/liquor/area/list',
      name: 'area-list',
      component: () => import('./views/liquor/LiquorAreaList.vue')
    },
    {
      path: '/liquor/area/:id',
      name: 'area',
      component: () => import('./views/liquor/LiquorArea.vue')
    },
    {
      path: '/liquor/detail/:id',
      name: 'detail',
      component: () => import('./views/liquor/LiquorDetail.vue')
    },
    {
      path: '/liquor/country',
      name: 'mater-area',
      component: () => import('./views/liquor/LiquorMasterArea.vue')
    },
    {
      path: '/liquor/brewing',
      name: 'brewing',
      component: () => import('./views/liquor/LiquorBrewing.vue')
    },

    {
      path: '/liquor/category',
      name: 'liquor-category',
      component: () => import('./views/liquor/LiquorCategory.vue')
    },
    {
      path: '/liquor/food-wine',
      name: 'liquor-food-wine',
      component: () => import('./views/liquor/LiquorFoodWine.vue')
    },
    {
      path: '/liquor/tasting',
      name: 'liquor-tasting',
      component: () => import('./views/liquor/LiquorTasting.vue')
    },
    {
      path: '/liquor/dana',
      name: 'liquor-word',
      component: () => import('./views/liquor/LiquorWord.vue')
    },
    {
      path: '/liquor/game',
      name: 'liquor-game',
      component: () => import('./views/liquor/Game.vue')
    },
    {
      path: '/liquor/life',
      name: 'liquor-life',
      component: () => import('./views/liquor/LiquorLife.vue')
    },
    {
      path: '/cast-screen',
      name: 'cast-screen',
      component: () => import('./views/CastScreen.vue')
    },
    {
      path: '/product',
      name: 'home',
      component: Home
    },
    {
      path: '/product/list',
      name: 'product-list',
      component: () => import('./views/ProductHome.vue')
    },
    {
      path: '/product/baike/:id',
      name: 'product-baike',
      component: () => import('./views/ProductBaike.vue')
    },
    {
      path: '/product/chain/:id',
      name: 'product-chain',
      component: () => import('./views/ProductChain.vue')
    },
    {
      path: '/product/dashboard/:id',
      name: 'product-dashboard',
      component: () => import('./views/ProductDashboard.vue')
    },
    // {
    //   path: '/service',
    //   name: 'service',
    //   component: () => import('./views/ProductService.vue'),
    // },
    {
      path: '/service/yxzt',
      name: 'service-yxzt',
      component: () => import('./views/ProductServiceYxzt.vue')
    },
    {
      path: '/service/fwxs',
      name: 'service-fwxs',
      component: () => import('./views/ProductServiceFwxs.vue')
    },
    {
      path: '/service/detail/:id',
      name: 'service-detail',
      component: () => import('./views/ProductServiceDetail.vue')
    },
    {
      path: '/ovop',
      name: 'ovop',
      component: () => import('./views/OneVillageOneProductExplore.vue')
    },
    {
      path: '/ovop/list',
      name: 'ovop-explore',
      component: () => import('./views/OneVillageOneProduct.vue')
    },
    {
      path: '/ovop/detail/:id',
      name: 'ovop-detail',
      component: () => import('./views/OneVillageOneProductDetail.vue')
    },
    {
      path: '/my',
      name: 'my',
      component: () => import('./views/My.vue')
    },
    {
      path: '/liquor/game/prize',
      name: 'prize',
      component: () => import('./views/m/Code.vue')
    },
    {
      path: '/liquor/login',
      name: 'liquor-login',
      component: () => import('./views/liquor/Login.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/demo',
      name: 'demo',
      component: () => import('./views/Demo.vue')
    },
    {
      path: '/product/place',
      name: 'product-place',
      component: () => import('./views/productPlace/ProductPlace.vue')
    },
    // 自有品牌
    {
      path: '/ownBrandProduct',
      name: 'ownBrandProduct',
      component: () => import('./views/ownBrandProduct/OwnBrandProduct.vue')
    },
    {
      path: '/ownBrandProduct/detail/:id',
      name: 'ownBrandProduct-detail',
      component: () => import('./views/ownBrandProduct/OwnBrandProductDetail.vue')
    },
    {
      path: '/product/foodBestInfo/:id',
      name: 'product-foodBestInfo',
      component: () => import('./views/ownBrandProduct/ProductFoodBest.vue')
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
// router.beforeEach(async (to, from, next) => {
//   if (to.name === 'prize') {
//     next();
//   }
//   // console.log(to);
//   if (to.name === 'login' || to.name === 'liquor-login') {
//     next();
//   }
//   if (to.path.startsWith('/liquor')) {
//     next();
//   } else {
//     const me = await ajax.doPost({
//       packageName: "sys",
//       className: "sysUser",
//       methodName: "me",
//     });
//
//     if (me.authorities.find(e => e.authority === 'ROLE_ADMIN' || e.authority === 'ROLE_WIKI')) {
//       next();
//     } else {
//       if (me.authorities.find(e => e.authority === 'ROLE_WIKI_LIQUOR')) {
//         next('/liquor/index')
//       } else {
//         next('/login')
//       }
//     }
//   }
//
// });
export default router
